import { render, staticRenderFns } from "./PriceVariants.vue?vue&type=template&id=07c131fc"
import script from "./PriceVariants.vue?vue&type=script&lang=js"
export * from "./PriceVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports